export const getCookie = (name: string) => {
  if (typeof window !== 'undefined') {
    const cookies = document.cookie.split(';');
    const cookieObject = cookies.reduce(
      (acc: { [key: string]: string }, cookie) => {
        const [key, value] = cookie.trim().split('=');
        acc[key] = decodeURIComponent(value);
        return acc;
      },
      {},
    );

    return cookieObject[name]
      ? decodeURIComponent(cookieObject[name])
      : undefined;
  }
};

export const setCookie = (name: string, value: string) => {
  if (typeof window !== 'undefined') {
    // 현재 시간
    const now = new Date();

    // 오늘 자정 (다음날 00:00:00) 계산
    const midnight = new Date(now);
    midnight.setUTCHours(23, 59, 59, 999); // 자정 설정

    // 자정까지의 남은 시간 (밀리초 단위)
    const expires = midnight.toUTCString();

    // 쿠키 설정 (오늘 자정까지 만료)
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires}`;
  }
};
